// extracted by mini-css-extract-plugin
export var errorIcon = "_me-1";
export var nameLogo = "_me-0";